// Small pure helpers for the password screens (tested in test/password.test.ts).

export const MIN_PASSWORD_LENGTH = 10;

/** The reset email's button opens /reset#email=…&code=… (the fragment never reaches a server). */
export function parseResetFragment(hash: string): { email: string; code: string } | null {
  const q = new URLSearchParams(hash.replace(/^#/, ''));
  const email = (q.get('email') ?? '').trim();
  const code = cleanCodeInput(q.get('code') ?? '');
  if (!email || code.length !== 6) return null;
  return { email, code };
}

/** The invitation link's #email=…&token=… (admin PR 3b), or null when it isn't one. */
export function parseInviteFragment(hash: string): { email: string; token: string } | null {
  const q = new URLSearchParams(hash.replace(/^#/, ''));
  const email = (q.get('email') ?? '').trim();
  const token = (q.get('token') ?? '').trim();
  if (!email || !/^[A-Za-z0-9_-]{32}$/.test(token)) return null;
  return { email, token };
}

/** What the code box keeps of what was typed or pasted: digits only, at most 6. */
export function cleanCodeInput(raw: string): string {
  return raw.replace(/[^0-9]/g, '').slice(0, 6);
}

/** Problem with a new password + its repeat, or null when it can be sent. */
export function newPasswordProblem(password: string, repeat: string): string | null {
  if (password.length < MIN_PASSWORD_LENGTH) return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
  if (password.length > 200) return 'That password is too long.';
  if (repeat !== password) return 'The two passwords don’t match.';
  return null;
}

/** Looks like an email address (same rule as the server): something@domain.tld, no spaces. */
export function looksLikeEmail(raw: string): boolean {
  const e = raw.trim();
  return e.length <= 100 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
}
